var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link, useLocation } from 'react-router-dom';
// import Req from "~/Utils/Req";
// import { Menu } from 'antd';
// import Companies, { CompanyIcon } from './Companies';
// import Style from "./index.css";
// import { useTheme } from '@mui/material';
// import Style from "./index.css";
import ReadMeData from "~/Data/ReadMe.json";
import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container/Container';
import HomeIcon from '@mui/icons-material/Home';
import { PrefixUri } from '~/Utils/Util';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { default as MuiLink } from '@mui/material/Link/Link';
import { Helmet } from 'react-helmet-async';
import WrapMarkdown from '~/Components/WrapMarkdown';
export default (function () {
    var pathname = useLocation().pathname;
    console.log("pathname=".concat(pathname));
    var readMe = ReadMeData;
    var searchTarget = {
        Title: "",
        TitleId: "",
        Content: "",
        SubContents: readMe,
    };
    // let titleAndContent: TitleAndContent | null = searchTarget;
    var breadcrumbInfos = [];
    var pathSplit = pathname.substring(1).split('/');
    var noResult = false;
    for (var index = 0; index < pathSplit.length; index++) {
        var pathFragment = pathSplit[index];
        var found = false;
        for (var searchSubIndex = 0; searchSubIndex < searchTarget.SubContents.length; searchSubIndex++) {
            var subResult = searchTarget.SubContents[searchSubIndex];
            // console.log(`path=${pathFragment} -> ${subResult.TitleId}`);
            if (subResult.TitleId === pathFragment) {
                console.log("yes: path=".concat(pathFragment, " -> ").concat(subResult.TitleId));
                breadcrumbInfos.push({
                    Title: subResult.Title,
                    TitleId: subResult.TitleId,
                    HasContent: subResult.Content !== "",
                    URI: "/" + PrefixUri.apply(void 0, __spreadArray(__spreadArray([], breadcrumbInfos.map(function (_a) {
                        var TitleId = _a.TitleId;
                        return TitleId;
                    }), false), [subResult.TitleId], false))
                });
                found = true;
                searchTarget = subResult;
                break;
            }
            else {
                console.log("no:  path=".concat(pathFragment, " -> ").concat(subResult.TitleId));
            }
        }
        if (!found) {
            noResult = true;
            break;
        }
    }
    if (noResult) {
        return (_jsx("p", { children: "Not Found" }));
    }
    if (breadcrumbInfos[0].TitleId !== "") {
        breadcrumbInfos.unshift({
            Title: "",
            TitleId: "",
            HasContent: true,
            URI: "",
        });
    }
    return (_jsxs(Container, { maxWidth: "xl", children: [_jsx(Helmet, { children: _jsx("title", { children: searchTarget.Title === '' ? 'SaintsField' : "".concat(searchTarget.Title, " | SaintsField") }) }), _jsxs(Box, { children: [_jsx(Breadcrumbs, { children: breadcrumbInfos.map(function (_a, index) {
                            var TitleId = _a.TitleId, Title = _a.Title, URI = _a.URI, HasContent = _a.HasContent;
                            if (TitleId === "") {
                                return _jsx(MuiLink, { to: "/", component: Link, children: _jsx(HomeIcon, {}) }, "");
                            }
                            var isLast = index === breadcrumbInfos.length - 1;
                            if (isLast || !HasContent) {
                                return _jsx(Typography, { sx: { color: isLast ? 'text.primary' : 'text.disabled', textDecoration: isLast ? 'underline' : undefined }, children: _jsx(WrapMarkdown, { disallowedElements: ['p'], unwrapDisallowed: true, children: Title }) }, TitleId);
                            }
                            return _jsx(MuiLink, { underline: "hover", color: "inherit", to: URI, component: Link, children: _jsx(WrapMarkdown, { disallowedElements: ['p'], unwrapDisallowed: true, children: Title }) }, TitleId);
                        }) }), _jsx(Typography, { variant: "h3", gutterBottom: true, sx: { wordBreak: 'break-all' }, children: _jsx(WrapMarkdown, { disallowedElements: ['p'], unwrapDisallowed: true, children: searchTarget.Title }) }), searchTarget.Content !== "" && _jsx(WrapMarkdown, { children: searchTarget.Content })] })] }));
});
